// api.js
// const API_BASE_URL = 'http://localhost:5000/api';

const API_BASE_URL = 'https://landnest.net:7000/api';


export const getMapProperties = async (filters) => {
  const params = new URLSearchParams();

  params.append("type", "lease");

  // Send propertyType
  if (filters.propertyType && filters.propertyType.length > 0) {
    const typeValue = Array.isArray(filters.propertyType) 
      ? filters.propertyType.join(',') 
      : filters.propertyType;
    params.append("propertyType", typeValue);
  }

  if (filters.bounds) {
    params.append('south', filters.bounds.south);
    params.append('north', filters.bounds.north);
    params.append('west', filters.bounds.west);
    params.append('east', filters.bounds.east);
  }

  if (filters.zoom) params.append('zoom', filters.zoom);
  if (filters.priceMin != null) params.append('priceMin', filters.priceMin);
  if (filters.priceMax != null) params.append('priceMax', filters.priceMax);
  if (filters.limit) params.append('limit', filters.limit);

  try {
    const response = await fetch(`${API_BASE_URL}/properties/map?${params.toString()}`);
    const data = await response.json();

    console.log("API Response:", data);

    if (!response.ok) {
      throw new Error(data.error || "Failed to fetch");
    }

    return data;

  } catch (error) {
    console.error("API Error:", error);
    return { success: false, properties: [], count: 0 };
  }
};

export const getPropertyDetails = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/properties/${id}`);
    const data = await response.json();
    
    if (!response.ok) throw new Error(data.error || 'Failed to fetch');
    return data;
  } catch (error) {
    console.error('API Error:', error);
    return { success: false, property: null };
  }
};

export const getFilterOptions = async () => {
  try {
    // ✅ Send type=lease to get only LEASE categories
    const response = await fetch(`${API_BASE_URL}/properties/options/filters?type=lease`);
    const data = await response.json();
    
    console.log('Filter options response:', data);
    
    if (!response.ok) throw new Error(data.error || 'Failed to fetch');
    return data;
  } catch (error) {
    console.error('API Error:', error);
    return { 
      success: false, 
      categories: [],
      priceRange: { min: 0, max: 5000000000 },
      totalProperties: 0
    };
  }
};

export const getPropertyImages = async (propertyId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/properties/${propertyId}/images`);
    const data = await response.json();
    
    if (!response.ok) throw new Error(data.error || 'Failed to fetch images');
    return data;
  } catch (error) {
    console.error('API Error fetching images:', error);
    return { success: false, images: [] };
  }
};

export const getBatchPropertyImages = async (propertyIds) => {
  try {
    const response = await fetch(`${API_BASE_URL}/properties/images/batch`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ propertyIds }),
    });
    const data = await response.json();
    
    if (!response.ok) throw new Error(data.error || 'Failed to fetch images');
    return data;
  } catch (error) {
    console.error('API Error fetching batch images:', error);
    return { success: false, images: {} };
  }
};







export const getUserWishlist = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/get-user-cart/${userId}/`);
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to fetch wishlist');
    return { success: true, data: data };
  } catch (error) {
    console.error('Error fetching wishlist:', error);
    return { success: false, data: [] };
  }
};

// Add to wishlist
export const addToWishlist = async (userId, propertyId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/user-cart/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        user_id: userId, 
        property_id: propertyId 
      }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to add to wishlist');
    return { success: true, data: data };
  } catch (error) {
    console.error('Error adding to wishlist:', error);
    return { success: false, error: error.message };
  }
};

// Remove from wishlist
export const removeFromWishlist = async (cartId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/user-cart/${cartId}/`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Failed to remove from wishlist');
    return { success: true };
  } catch (error) {
    console.error('Error removing from wishlist:', error);
    return { success: false, error: error.message };
  }
};